let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bQCV5")).then(() => parcelRequire('7b1u7'));